import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';

type FinancialsPlaceholderData = {
  title: string;
  description: string;
};

@Component({
  selector: 'app-financials-placeholder',
  standalone: true,
  templateUrl: './financials-placeholder.component.html',
})
export class FinancialsPlaceholderComponent {
  private readonly route = inject(ActivatedRoute);
  readonly content = toSignal(
    this.route.data.pipe(map(data => data as FinancialsPlaceholderData)),
    { initialValue: this.route.snapshot.data as FinancialsPlaceholderData },
  );
}
